<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <v-row class="child-flex" >
        <v-card>
          <v-card-text>
            <v-card-title>
              <v-col class="text-h4">Edit Profile</v-col>
            </v-card-title>
            <v-form>
              <v-text-field
                v-validate="'required'"
                v-model="profile.name"
                :error-messages="errors.collect('name')"
                label="Name"
                data-vv-name="name"
                required />
              <v-text-field
                v-validate="'required|email'"
                v-model="profile.email"
                :error-messages="errors.collect('email')"
                type="email"
                label="Email"
                data-vv-name="email"
                required />
              <v-text-field
                v-mask="'+1##########'"
                v-validate="'required'"
                v-model="profile.phone_number"
                :error-messages="errors.collect('phone')"
                label="Phone"
                data-vv-name="phone_number"
                required />

              <v-radio-group v-model="profile.preferred_mfa" mandatory>
                <v-radio label="SMS" :value="SMS_MFA"></v-radio>
                <v-radio label="Software Based - TOTP" :value="TOTP_MFA"></v-radio>
              </v-radio-group>

              <v-btn
                color="primary"
                type="submit"
                class="mr-2"
                @click.prevent="validateAndSubmit"
               >
               Save
               </v-btn>
              <v-btn :to="{ name: 'root_path' }" class="mr-2">Cancel</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-row>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
import { mapFields } from 'vee-validate'
import { mapState } from 'vuex'
import { SMS_MFA, TOTP_MFA } from '@/constants'

export default {
  name: 'profile',
  data: function () {
    return {
      SMS_MFA,
      TOTP_MFA
    }
  },
  computed: {
    ...mapFields(['name', 'email']),
    ...mapState('ProfileStore', {
      profile: 'profile'
    })
  },
  mounted: function () {
    this.$logger.trace('Fetching Profile')
    this.$store.dispatch('ProfileStore/getProfile')
      .then((response) => {
        this.$logger.trace('Profile fetched')
      })
      .catch(error => {
        this.$logger.error('Error loading Profile', error.message)
        this.$flash({
          showClose: true,
          message: 'Error Loading Profile. ' + error.message,
          type: 'error'
        })
      })
  },
  methods: {
    validateAndSubmit () {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.saveProfile()
        }
      })
    },
    saveProfile () {
      this.$store
        .dispatch('ProfileStore/saveProfile', this.profile)
        .then(response => {
          this.$logger.trace(response)
          this.$router.push({ name: 'root_path' })
          this.$flash({
            showClose: true,
            message: `Saved Profile for ${this.profile.name}`,
            type: 'success',
            duration: 2000
          })
        })
        .catch(error => {
          this.$logger.error(error.message)
          this.$flash({
            showClose: true,
            message: 'Error Saving Profile. ' + error.message,
            type: 'error',
            duration: 0
          })
        })
    }
  }
}
</script>
